<div class="panel">
    <div class="panel-heading px-3">
        <h3 class="pr-3" translate="UNASSIGNED_EMPLOYEE_TASKS"></h3>
        <app-info-tooltip appCustomPopover placement="right" popoverType="warning"
                          popoverText="UNASSIGNED_EMPLOYEE_TASKS_INFO">

        </app-info-tooltip>
    </div>
    <div class="panel-body px-3">
        <app-table
            id="unassigned-tasks"
            class="unassigned-tasks-table"
            [loadingItems]="loading"
            [loadingTable]="reloading"
        >
            <ng-container header>
                <th class="flex-4" appHeaderSort="serviceName" appTitleProvider>
                    <span>{{ 'TASK' | translate }}</span>
                </th>
                <th class="flex-2" *ngIf="rosterPresent"
                    appHeaderSort="rosterDepartmentName" appTitleProvider>
                    <span>{{ 'ROSTER_NAME' | translate }}</span>
                </th>
                <th class="flex-4" appTitleProvider appHeaderSort="skillLevelDescription">
                    <span>{{ 'COMPETENCE' | translate }}</span>
                </th>
                <th class="flex-3" appTitleProvider appHeaderSort="fromTime,toTime">
                    <span>{{ 'TIME' | translate }}</span>
                </th>
                <th class="flex-2" appTitleProvider appHeaderSort="duration">
                    <span>{{ 'DURATION' | translate }}</span>
                </th>
                <th class="flex-2" appTitleProvider appHeaderSort="numberOfEmployees">
                    <span>{{ 'COUNT' | translate }}</span>
                </th>
                <th *ngIf="isGeneralSkillUpdateFeatureEnabled | async"
                    class="flex-1 justify-content-center" appTitleProvider>
                    <span>{{ 'ACTIONS' | translate }}</span>
                </th>
                <th class="flex-1"></th>
                <th class="icon-column"></th>
                <th class="icon-drag-column"></th>
            </ng-container>
            <ng-container body>
                <div
                    cdkDropList
                    cdkDropListSortingDisabled
                    [cdkDropListData]="tasks"
                    (cdkDropListDropped)="drop($event)"
                    (cdkDropListExited)="exited($event)"
                    (cdkDropListEntered)="entered($event)"
                >
                    <ng-container>
                        @for (task of tasks; track task.taskId) {
                            <tr
                                [ngClass]="{ 'drag-placeholder-visible': task.numberOfEmployees > 0 }"
                                cdkDrag
                                [cdkDragData]="task"
                                [cdkDragDisabled]="
                                disableDrag ||
                                task.feasibilityInfo.syncedCapacityError ||
                                isTaskUnallocated(task) ||
                                task.feasibilityInfo.durationExceedsTimeWindowError
                            "
                                (cdkDragStarted)="started($event)"
                                (cdkDragReleased)="released()"
                                *ngIf="!task.editing"
                            >
                                <td class="flex-4" appTitleProvider>
                                    <span>{{ task.serviceName }}</span>
                                </td>
                                <td class="flex-2" *ngIf="rosterPresent" appTitleProvider>
                                    <span>{{ task.rosterDepartmentName }}</span>
                                </td>
                                <td class="flex-4" appTitleProvider>
                                    <span>{{ task.skillRequirementDescription }}</span>
                                </td>
                                <td class="flex-3" appTitleProvider>
                                    <span>{{ task | fromto }}</span>
                                </td>
                                <td class="flex-2" appTitleProvider>
                                    <span>{{ task.duration }} min</span>
                                </td>
                                <td class="flex-2 drag-preview-hide-col" appTitleProvider>
                                    <span>{{ task.numberOfEmployees > 0 ? task.numberOfEmployees : '1' }}</span>
                                </td>
                                <td class="flex-1 justify-content-center"
                                    *ngIf="isGeneralSkillUpdateFeatureEnabled | async">
                                    <app-tooltip
                                        title="{{'EDIT_TASK' | translate}}"
                                        (click)="editTask(task, $event)"
                                    >
                                        <ng-container icon>
                                        <span
                                            class="vismaicon vismaicon-sm vismaicon-edit"
                                            *ngIf="!task.isSyncedInitially"
                                        ></span>
                                        </ng-container>
                                    </app-tooltip>
                                <td class="flex-1 drag-preview-hide-col">
                                    <app-employee-task-feasibility-info
                                        *ngIf="isTaskUnallocated(task)"
                                        [feasibilityInfo]="task.feasibilityInfo"
                                    ></app-employee-task-feasibility-info>
                                </td>
                                <td class="icon-column justify-content-end">
                                    <app-tooltip
                                        *ngIf="task.streetAddressNameNumberAndLetter"
                                        class="pointer"
                                        (click)="openAdminTaskAddressModal(task)"
                                        appCustomPopover
                                        placement="top"
                                        [adaptPlacement]="true"
                                        [popoverType]="task.addressIsValid ? 'default' : 'error'"
                                        [popoverText]="task.addressIsValid ? task.streetAddressNameNumberAndLetter : 'FEASIBILITY_ADDRESS_NOT_FOUND_ERROR'"
                                    >
                                        <ng-container icon>
                                        <span [ngClass]="{'icon-location-blue': task.addressIsValid,
                                                          'icon-location-red': !task.addressIsValid }"></span>
                                        </ng-container>
                                    </app-tooltip>
                                </td>
                                <td class="icon-drag-column">
                                    <app-tooltip
                                        title="{{'DRAG_TASK' | translate}}"
                                        [compact]="true"
                                        *ngIf="
                                        !disableDrag &&
                                        !task.feasibilityInfo.syncedCapacityError &&
                                        !isTaskUnallocated(task) &&
                                        !task.feasibilityInfo.durationExceedsTimeWindowError
                                    "
                                    >
                                        <ng-container icon>
                                            <span class="vismaicon icon-draggable-indicator"></span>
                                        </ng-container>
                                    </app-tooltip>
                                </td>
                            </tr>
                            <app-employee-unassigned-tasks-edit [unassignedTaskParam]="task"
                                                                (disableDraggingEmitter)="disableDrag = $event"
                                                                (updateGeneralTaskListEmitter)="loadGeneralTasks()"
                                                                *ngIf="task.editing"></app-employee-unassigned-tasks-edit>
                        }
                    </ng-container>
                </div>
            </ng-container>
        </app-table>
    </div>
</div>
